import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import LightSpinnerWrapper from './../Wrappers/LightSpinnerWrapper/LightSpinnerWrapper'

export default class NavigationBox extends Component {
    static propTypes = {
        total: PropTypes.number,
        current: PropTypes.number,
        onChange: PropTypes.func,
        isLoading: PropTypes.bool
    }

    static defaultProps = {
        isLoading: false
    }

    constructor(props) {
        super(props);

        this.moveNext = this.moveNext.bind(this);
        this.movePrevious = this.movePrevious.bind(this);
    }

    movePrevious() {
        if (this.props.current > 0) {
            this.props.onChange(this.props.current - 1)
        }
    }

    moveNext() {
        if (this.props.current < this.props.total - 1) {
            this.props.onChange(this.props.current + 1)
        }
    }

    render() {
        return (
            <div className="notranslate no-print article-navigation-box">

                <div className={"button-previous la-TriangleLeft " +
                    (this.props.current === 0 || this.props.isLoading ? "disabled" : "")}
                     onClick={this.movePrevious}>
                </div>

                <span className="counter">
                    <LightSpinnerWrapper isLoading={this.props.isLoading}>
                        <span>
                            {this.props.current + 1}
                            &nbsp; <FormattedMessage id="Dashboard_Charts_UIText_dashboard.counter.of" /> &nbsp;
                            {this.props.total}
                            &nbsp; <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </span>
                    </LightSpinnerWrapper>
                </span>
                <div className={"button-next la-TriangleRight " +
                    (this.props.current === this.props.total - 1  || this.props.isLoading? "disabled" : "")}
                     onClick={this.moveNext}>
                </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/NavigationBox/NavigationBox.jsx